import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateGlobalFieldBindings } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';
import type { FieldBindingDto } from '@dealstack/frontend/shared/components/FieldBinding/useFieldBindingState.types.ts';
import { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { documentTemplateMutationError } from '@dealstack/frontend/app/pages/DocumentTemplates/api/documentTemplateMutationError';
import { buildGlobalFieldBindingsQueryKey } from './useGlobalFieldBindingsQuery';

interface Params {
	templateId: string;
	bindings: FieldBindingDto[];
}

export const useUpdateGlobalFieldBindings = () => {
	const tDefault = useTranslationDefault();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ templateId, bindings }: Params) =>
			updateGlobalFieldBindings(templateId, bindings),
		onSuccess: async (_, { templateId }) => {
			await queryClient.invalidateQueries({
				queryKey: [buildGlobalFieldBindingsQueryKey(templateId)],
			});
			showToastV2({
				title: tDefault('document_templates.field_binding.toast.updated'),
			});
		},
		onError: (error: unknown) => documentTemplateMutationError(error, tDefault),
	});
};
